




import { Component, Prop, Vue } from 'vue-property-decorator';

import Main from '@/app/components/Main/Main';

@Component({
  components: {
    Main,
  },
})
export default class App extends Vue { }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/App.vue